var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtBorderGuedelon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bouton-guedelon-utils",
    preserveAspectRatio: "none",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.4 52",
    style: {
      enableBackground: "new 0 0 144.4 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.bouton-guedelon-utils .st0{fill:none;stroke:#E87722;stroke-width:3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bt-border-guedelon",
    className: "st0",
    d: "M2.7,1.5c-0.5,0-0.3,0.6-0.6,0.8C3,19.5,2.7,24.8,1.6,50.5c7.3-0.2,132.5,0,138.9,0 c0.6-19.2,2.4-29.7,2.4-48.2C134.1,1.5,9.8,2.5,2.7,1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtBorderGuedelon);
export default __webpack_public_path__ + "static/media/bt-border-guedelon.5c38edba32fea8dd2555c5e2c61027c2.svg";
export { ForwardRef as ReactComponent };